import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import $ from "jquery";
import "jqueryui";

import ReactToPrint, { PrintContextConsumer } from "react-to-print";

import * as layoutActions from "store/modules/rds_layout";

import { MdClose } from "react-icons/md";
import { Button, Input } from "semantic-ui-react";
import SisSelect from "store/sis/component/SisSelect";

import css from "./sisPrint.module.scss";

import { Map, View, Overlay } from "ol";
import { Vector as VectorLayer, Tile as TileLayer } from "ol/layer";
import { Vector as VectorSource, TileWMS, XYZ, WMTS } from "ol/source";
import { Style, Stroke, Fill, Text } from "ol/style";
import { Projection } from "ol/proj";
import { register } from "ol/proj/proj4";
import TileGrid from "ol/tilegrid/TileGrid";
import { defaults as DefaultInteractions } from "ol/interaction";
import { defaults as DefaultControls } from "ol/control";
import proj4 from "proj4";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { getTopLeft } from "ol/extent";
import { transform } from "ol/proj";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
//import {saveAs} from "file-saver";
//import {toStringHDMS} from "ol/coordinate";

class Print extends Component {
	constructor(props) {
		super(props);

		this.printWrap = React.createRef();
		this.mapWrap = React.createRef();
		this.map = React.createRef();
		this.downloadWrap = React.createRef();
	}

	componentDidMount() {
		this.props.LayoutActions.setPrint(this.printWrap.current);
	}

	openMap = () => {
		const { sisMap } = this.props.sis;

		var type = $(`select#selectType`).val();
		var paper,
			width,
			height = "";

		switch (type) {
			case "A4H":
				paper = "A4H";
				width = "277";
				height = "190";
				break;
			case "A4V":
				paper = "A4V";
				width = "190";
				height = "277";
				break;
			case "A3H":
				paper = "A3H";
				width = "400";
				height = "277";
				break;
			case "A3V":
				paper = "A3V";
				width = "277";
				height = "400";
				break;
			case "A0H":
				paper = "A0H";
				width = "1169";
				height = "821";
				break;
			case "A0V":
				paper = "A0V";
				width = "821";
				height = "1169";
				break;
		}

		$(`.${css.mapPrint}`).css({
			width: width + "mm",
			height: height + "mm",
		});

		let left = $(`.${css.mapPrint}`).width() / 2;
		let top = $(`.${css.mapPrint}`).height() / 2;

		if (left > 700) left = 700;
		if (top > 400) top = 400;

		top += 40;

		$(`.${css.wrap}`).css({
			left: `calc(50% - ${left}px)`,
			top: `calc(50% - ${top}px)`,
		});

		$(this.mapWrap.current).show();

		const sisPrint = new SisPrint("printMap", sisMap.map, paper);

		this.setState({
			sisPrint,
			paper,
		});
	};

	close = () => {
		$(this.printWrap.current).hide();
	};

	printClose = () => {
		$(this.map.current).html("");
		$(this.mapWrap.current).hide();
	};

	// 이미지 다운로드
	download = () => {
		this.state.sisPrint.download(this.downloadWrap.current);
	};

	// PDF
	pdf = () => {
		this.state.sisPrint.downloadPDF(this.downloadWrap.current, this.state.paper);
	};

	// 출력
	printMap = () => {
		let inbody = document.body.innerHTML;

		window.onbeforeprint = function () {
			document.body.innerHTML = $(`.${css.mapPrint}`).html();
		};

		window.onafterprint = function () {
			document.body.innerHTML = inbody;
		};

		window.print();
	};

	render() {
		return (
			<>
				<div className={`${css.mapPrintWrap} sisModalWrap`} style={{ minHeight: "0" }} ref={this.printWrap}>
					<div className={css.printSelectWrap}>
						<div className={css.title}>
							<span>프린트 설정</span>
							<div className={css.right}>
								<div className={css.close} onClick={this.close}>
									<MdClose size="30px" />
								</div>
							</div>
						</div>

						<div className={css.typeSelectWrap}>
							<SisSelect
								id="selectType"
								items={[
									{
										type: "A4H",
										text: "A4 가로",
									},
									{
										type: "A4V",
										text: "A4 세로",
									},
									{
										type: "A3H",
										text: "A3 가로",
									},
									{
										type: "A3V",
										text: "A3 세로",
									},
									{
										type: "A0H",
										text: "A0 가로",
									},
									{
										type: "A0V",
										text: "A0 세로",
									},
								]}
								defaultValue={"A4V"}
								className={css.selectbox}
								mapping={{
									key: "type",
									text: "text",
								}}
								onChange={this.getEmd}
								onLoaded={this.getEmd}
							/>

							<Button color="youtube" onClick={this.openMap}>
								보기
							</Button>
						</div>
					</div>
				</div>

				<div className={css.mapWrap} ref={this.mapWrap}>
					<div className={css.wrap}>
						<div className={css.title}>
							<span>출력/다운로드</span>
							<div className={css.right}>
								<ReactToPrint content={() => this.mapPrint}>
									<PrintContextConsumer>
										{({ handlePrint }) => (
											<Button color="youtube" onClick={handlePrint}>
												출력
											</Button>
										)}
									</PrintContextConsumer>
								</ReactToPrint>
								<Button color="youtube" onClick={this.download}>
									이미지
								</Button>
								<Button color="youtube" onClick={this.pdf}>
									PDF
								</Button>
								<div className={css.close} onClick={this.printClose}>
									<MdClose size="30px" />
								</div>
							</div>
						</div>

						<div className={css.printWrap} ref={this.downloadWrap}>
							{/*<Loader className={css.loader} content="Loading" />*/}

							<div className={css.mapPrint} ref={(ref) => (this.mapPrint = ref)}>
								<label>
								<Input className={css.comment} placeholder="메모를 작성하여 주세요." />
								</label>
								<div id="printMap" className={css.map} ref={this.map}></div>
								<span className={css.footer}>
									본 자료는 공개제한 자료임으로 취급에 주의하시기 바라며,
									<br />
									실제 현황과 차이가 있을 수 있으므로 참고용으로만 활용하시기 바랍니다.
								</span>
							</div>
						</div>
					</div>

					<div className={css.transparent} ref={this.transparent}></div>
				</div>
			</>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(Print);

class SisPrint {
	constructor(mapId, parentMap, paper) {
		if (!mapId) {
			alert("Print MapId를 설정해 주세요");
			return false;
		}

		if (!parentMap) {
			alert("Parent Map을 설정해 주세요");
			return false;
		}

		this.paper = paper;
		this.pMap = parentMap;
		this.lyrList = parentMap.getLayers().getArray();
		this.mapId = mapId;

		this.printLayer = null;

		this._init({});
	}

	extendProps = (props) => {
		this.props = $.extend({}, this.props, props);
	};

	_init = (props) => {
		this.extendProps(props);

		this._setProj4();
		this._createMap();
	};

	_setProj4 = () => {
		proj4.defs(
			"EPSG:5181",
			// '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs',
			"+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
		);
		proj4.defs("EPSG:5185", "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5186", "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5187", "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5188", "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5174", "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +towgs84=-115.80,474.99,674.11,1.16,-2.31,-1.63,6.43");
		proj4.defs("EPSG:5179", "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
		proj4.defs("EPSG:4019", "+proj=longlat +ellps=GRS80 +no_defs");
		register(proj4);
	};

	_createMap = () => {
		//$("#loader").show();

		var self = this;
		var pMap = this.pMap;
		var isDrag = true;
		var extent = [];
		var center = [];
		var zoom = null;

		if (!extent.length) extent = pMap.getView().calculateExtent(pMap.getSize());
		if (!center.length) center = pMap.getView().getCenter();

		zoom = pMap.getView().getZoom();
		this.minZoom = zoom;
		this.maxZoom = zoom;

		this.map = new Map({
			target: this.mapId,
			renderer: "canvas",
			interactions: DefaultInteractions({
				doubleClickZoom: false,
				dragPan: isDrag,
				mouseWheelZoom: isDrag,
			}),
			controls: DefaultControls({
				attribution: false,
				collapsible: false,
				zoom: false,
				rotate: false,
			}).extend([
				// new Zoom({
				// 	duration: 0,
				// }),
				// new ZoomSlider(),
				// new FullScreen({}),
			]),
			view: new View({
				projection: pMap.getView().getProjection().getCode(),
				center: center,
				//extent,
				zoom: zoom,
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				resolutions: pMap.getView().getResolutions(),
			}),
		});
		this.loading = 0;
		this.loaded = 0;

		//this.map.on("postrender", function (evt) {
		//	setTimeout(function () {
		//		++self.loaded;

		//		if (self.loading === self.loaded) {
		//			$("#loader").hide();
		//			self.loading = 0;
		//			self.loaded = 0;
		//		}
		//	}, 100);
		//});

		//this.map.on("precompose", function (evt) {
		//	if (self.loading === 0) {
		//		setTimeout(function () {
		//			$("#loader").show();
		//		}, 100);
		//	}

		//	++self.loading;
		//});

		//this.map.on("rendercomplete", function (evt) {
		//	$("#loader").hide();
		//});

		this._addLayers();
	};

	_addLayers = () => {
		var self = this;

		let source = "",
			id = "",
			tempOverlay = null;

		const overalyers = this.pMap.getOverlays().getArray();
		const addOverlayers = [];

		overalyers.forEach((overlay, i) => {
			tempOverlay = new Overlay({
				element: $(overlay.getElement()).clone()[0],
				position: overlay.getPosition(),
				offset: overlay.getOffset(),
				positioning: overlay.getPositioning(),
			});

			addOverlayers.push(tempOverlay);
		});

		addOverlayers.reverse().forEach((item) => {
			self.map.addOverlay(item);
		});

		this._addDaum();

		this.pMap.getLayers().forEach((lyr, i) => {
			source = lyr.getSource();
			id = lyr.get("id");

			if (lyr instanceof TileLayer) {
				if (source instanceof XYZ) {
					if (id === "Daum") {
						this.daumMap.setVisible(lyr.getVisible());
					} else if (id === "DaumSatellite") {
						this.daumSatellite.setVisible(lyr.getVisible());
					} else if (id === "DaumHybrid") {
						this.daumHybrid.setVisible(lyr.getVisible());
					}
				} else if (source instanceof TileWMS) {
					this.addWmsLayer(lyr);
				} else {
					//this.addWmsLayer(lyr);
					this.createAirphoto(lyr);
				}
			}
			if (lyr instanceof VectorLayer) {
				const vector = new VectorLayer(lyr.getProperties());
				vector.setStyle(lyr.getStyle());

				self.map.addLayer(vector);
			}
		});
	};

	getParentLayerById = (id) => {
		var rtnLyr = null;
		this.pMap.getLayers().forEach(function (lyr, idx) {
			if (id === lyr.get("id")) {
				rtnLyr = lyr;
				return false;
			}
		});

		return rtnLyr;
	};

	addWmsLayer = (lyr) => {
		// var self = this;
		var visible = lyr.getVisible();

		lyr = new TileLayer({
			title: lyr.get("id"),
			id: lyr.get("id"),
			source: new TileWMS({
				projection: this.map.getView().getProjection().getCode(),
				url: "/map/proxy/wms.do",
				params: {
					LAYERS: lyr.get("name"),
					VERSION: "1.1.1",
					FORMAT: "image/png",
					TRANSPARENT: true,
					//						CQL_FILTER : filter
				},
				serverType: "geoserver",
				imageSmoothing: false,
			}),
			visible: visible,
			zIndex: lyr.getZIndex(),
			minZoom: lyr.getMinZoom(),
			maxZoom: lyr.getMaxZoom(),
			opacity: lyr.getOpacity(),
		});

		this.map.addLayer(lyr);

		return lyr;
	};

	// 항공영상 생성( 현재 5186만 적용됨 )
	// 수정본(20220608)
	createAirphoto = (item) => {
		let projection;
		let resolutions;
		let extent;
		let origin;
		var matrixIds, matrixSet;

		projection = "EPSG:5186";
		extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];
		origin = getTopLeft(extent);
		resolutions = [
			529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
			0.1322919312505292,
		];

		if (item.layerName.indexOf("2021") > -1) {
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
				`EPSG:5181_${item.layerName}:13`,
			];

			matrixSet = `EPSG:5181_${item.layerName}`;

			projection = new Projection({
				code: "EPSG:5181",
				extent: [-30000, -60000, 494288, 988576],
				units: "m",
			});

			extent = [-5423200.0,3144.0,343968.0,6294600.0];
			resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
			origin = [-5423200.0, 6294600.0];
		} else if (item.layerName.indexOf("2008_2009") > -1 || item.layerName.indexOf("2019") > -1) {
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5181_${item.layerName}`;
		} else {
			matrixIds = [
				`EPSG:5186_${item.layerName}:0`,
				`EPSG:5186_${item.layerName}:1`,
				`EPSG:5186_${item.layerName}:2`,
				`EPSG:5186_${item.layerName}:3`,
				`EPSG:5186_${item.layerName}:4`,
				`EPSG:5186_${item.layerName}:5`,
				`EPSG:5186_${item.layerName}:6`,
				`EPSG:5186_${item.layerName}:7`,
				`EPSG:5186_${item.layerName}:8`,
				`EPSG:5186_${item.layerName}:9`,
				`EPSG:5186_${item.layerName}:10`,
				`EPSG:5186_${item.layerName}:11`,
				`EPSG:5186_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5186_${item.layerName}`;

			extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];
			resolutions = [
				529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
				0.1322919312505292,
			];
		}

		this.layers[item.layerName] = new TileLayer({
			kind: item.type,
			title: item.layerName,
			id: item.layerName,
			zIndex: item.zindex,
			source: new WMTS({
				url: `/gwc/service/wmts`,
				// url: "/map/proxy/proxyBackgroundByUrl.do",
				// url: "http://sisnet.iptime.org:9002/gwc/service/wmts",
				layer: item.layerName,
				matrixSet: matrixSet,
				format: "image/png",
				projection,
				tileGrid: new WMTSTileGrid({
					origin,
					tileSize: [256, 256],
					extent,
					resolutions,
					matrixIds: matrixIds,
				}),
				imageSmoothing: false,
				wrapX: true,
			}),
			visible: item.visibility,
		});

		this.map.addLayer(this.layers[item.layerName]);
	};


	addLabelLayer = (layerName, params, callback) => {
		var self = this;

		this.wfs = this.wfs ? this.wfs : {};
		this.wfs[layerName] = new VectorLayer({
			id: layerName,
			projection: this.map.getView().getProjection().getCode(),
			declutter: true,
			source: new VectorSource({}),
		});

		this.wfs[layerName].setStyle(function (f) {
			var text = "";

			if (self.map.getView().getZoom() >= 10) {
				text = f.get("label");
			} else {
				text = "";
			}

			return [
				new Style({
					fill: new Fill({
						color: "rgba(255,255,255,0.4)",
					}),
					stroke: new Stroke({
						color: "#0000ff",
						width: 2,
					}),
					text: new Text({
						font: "15px Calibri,sans-serif",
						fill: new Fill({
							color: "#000",
						}),
						stroke: new Stroke({
							color: "#fff",
							width: 2,
						}),
						text: text,
						offsetX: 10,
						offsetY: -10,
						placement: "line",
						overflow: true,
					}),
				}),
			];
		});

		this.map.addLayer(this.wfs[layerName]);

		return this.wfs[layerName];
	};

	//Zoom으로부터 Resolution값 가져오기
	_getResolution = (zoom) => {
		return this.map.getView().getResolutionForZoom(zoom);
	};

	_addVWorld = (visible) => {
		var base = new TileLayer({
			id: "VWorld",
			title: "VWorld Street Map",
			visible: visible,
			source: new XYZ({
				url: "/map/proxy/proxyBackground.do?url=http://xdworld.vworld.kr:8080/2d/Base/201512/{z}/{x}/{y}.png",
				project: "EPSG:3857",
			}),
		});

		this.map.addLayer(base);
	};

	_addNaver = (visible) => {
		var resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
		var extent = [90112, 1192896, 2187264, 2765760]; // 4 * 3

		var projection = new Projection({
			code: "EPSG:5179",
			extent: extent,
			units: "m",
		});

		// define tile layer
		var base = new TileLayer({
			id: "Naver",
			title: "Naver Street Map",
			visible: visible,
			type: "base",
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					extent: extent,
					origin: [extent[0], extent[1]],
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;

					var s = Math.floor(Math.random() * 3) + 1; // 1 ~ 4
					var z = tileCoord[0] + 1;
					var x = tileCoord[1];
					var y = tileCoord[2];

					return "http://onetile" + s + ".map.naver.net/get/149/0/0/" + z + "/" + x + "/" + y + "/bl_vc_bg/ol_vc_an";
				},
			}),
		});

		this.map.addLayer(base);
	};

	// 다음지도 불러오기
	_addDaum = (visible) => {
		// 직접 불러오기
		var config = this.getBaseMap("daum");

		// var resolutions = config.resolutions;
		var resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
		var extent = config.extent;
		var origin = config.origin;
		var projection = new Projection({
			code: config.projection,
			extent: extent,
			units: "m",
		});

		// define tile layer
		this.daumMap = new TileLayer({
			id: "Daum",
			title: "Daum Street Map",
			visible: visible,
			type: "base",
			zIndex: -1,
			source: new XYZ({
				url: "/map/proxy/proxyBackground.do?x={x}&y={y}&z={z}&length=" + resolutions.length,
				projection: projection,
				tileSize: 256,
				tilePixelRatio: 1,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				// tileUrlFunction: function (tileCoord, pixelRatio, projection) {
				// 	if (tileCoord == null) return undefined;
				// 	if (tileCoord[0] >= 14) return undefined;
				// 	var s = Math.floor(Math.random() * 4); // 0 ~ 3
				// 	var z = resolutions.length - tileCoord[0];
				// 	var x = tileCoord[1];
				// 	var y = tileCoord[2] + 1;

				// 	return (
				// 		"http://map" +
				// 		s +
				// 		".daumcdn.net/map_2d/1810uis/L" +
				// 		z +
				// 		"/" +
				// 		-y +
				// 		"/" +
				// 		x +
				// 		".png"
				// 	);
				// },
			}),
		});

		this.daumSatellite = new TileLayer({
			id: "DaumSatellite",
			title: "Daum Satellite",
			visible: !visible,
			type: "base",
			source: new XYZ({
				// url: "/map/proxy/proxyBackgroundSatellite.do?x={x}&y={y}&z={z}&length=" + resolutions.length,
				// projection: projection,
				// tileSize: 256,
				// tilePixelRatio: 1,
				// minZoom: 0,
				// maxZoom: resolutions.length - 1,
				// tileGrid: new TileGrid({
				// 	origin: origin,
				// 	resolutions: resolutions,
				// }),

				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;

					return "/map/proxy/proxyBackgroundByUrl.do?url=http://map" + s + ".daumcdn.net/map_skyview/L" + z + "/" + -y + "/" + x + ".jpg?v=160114";
				},
			}),
		});

		this.daumHybrid = new TileLayer({
			id: "DaumHybrid",
			title: "Daum Hybrid",
			visible: !visible,
			type: "base",
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 3,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;

					return "/map/proxy/proxyBackgroundByUrl.do?url=http://map" + s + ".daumcdn.net/map_hybrid/1810uis/L" + z + "/" + -y + "/" + x + ".png";
				},
			}),
		});

		this.daumRoadView = new TileLayer({
			id: "roadview",
			title: "roadview",
			visible: false,
			type: "base",
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;
					return "http://map" + s + ".daumcdn.net/map_roadviewline/7.00/L" + z + "/" + -y + "/" + x + ".png";
				},
			}),
		});

		this.map.addLayer(this.daumMap);
		this.map.addLayer(this.daumSatellite);
		this.map.addLayer(this.daumHybrid);
		// this.map.addLayer(this.daumRoadView);
	};

	// 베이스맵 config 가져오기
	getBaseMap = (id) => {
		var baseMap;

		if (id.toLowerCase() === "vworld") {
			baseMap = {
				id: "VWorld",
				name: "VWorld",
				korName: "브이월드",
				projection: "EPSG:3857",
				tileSize: 256,
				center: [14121043.79, 4185661.96],
				extent: [14098021.61, 4170799.78, 14140057.41, 4199108.25],
				//					resolutions : [38.218514142588134, 19.109257071294067, 9.554628535647034, 4.777314267823517, 2.3886571339117584, 1.1943285669558792, 0.5971642834779396, 0.2985821417389698, 0.1492910708694849, 0.0746455354347425],
				resolutions: [2445.98490512564, 1222.99245256282, 611.49622628141, 305.748113140705, 152.8740565703525, 76.43702828517625, 38.21851414258813, 19.109257071294063, 9.554628535647032, 4.777314267823516, 2.388657133911758],
				//					resolutions : [ 38.21851414258813, 76.43702828517625, 152.8740565703525, 305.748113140705, 611.49622628141, 1222.99245256282, 2445.98490512564 ],
			};
		} else if (id.toLowerCase() === "daum") {
			baseMap = {
				id: "Daum",
				name: "Daum",
				korName: "다음",
				projection: "EPSG:5181",
				tileSize: 256,
				center: [186469.67, 184868.86],
				origin: [-30000, -60000],
				extent: [-30000 - Math.pow(2, 19) * 4, -60000, -30000 + Math.pow(2, 19) * 5, -60000 + Math.pow(2, 19) * 5],
				resolutions: [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25, 0.125, 0.0625, 0.03125],
			};
		} else if (id.toLowerCase() === "naver") {
			baseMap = {
				id: "Naver",
				name: "Naver",
				korName: "네이버",
				projection: "EPSG:5179",
				tileSize: 256,
				center: [940937.89, 1685177.3],
				extent: [90112, 1192896, 1990673, 2765760],
				resolutions: [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],
			};
		}

		return baseMap;
	};

	download = (ele) => {
		$("#loader").show();

		//this.map.once("postcompose", function (event) {
		$(ele).css({
			maxHeight: "9000px",
			maxWidth: "9000px",
		});

		html2canvas(ele).then(function (canvas) {
			if (navigator.msSaveBlob) {
				navigator.msSaveBlob(canvas.msToBlob(), "map.png");
			} else {
				var imgData = canvas.toDataURL("image/png");

				var a = document.createElement("a");
				a.download = "map.png";
				a.href = imgData;
				a.click();

				//canvas.toBlob(function (blob) {
				//	var url = URL.createObjectURL(blob);
				//	//url = data;

				//	var a = document.createElement("a");
				//	a.download = "map.png";
				//	a.href = url;
				//	a.click();
				//});
			}

			$(ele).css({
				maxHeight: "800px",
				maxWidth: "1200px",
			});

			$("#loader").hide();
		});
		//});
	};

	downloadPDF = (ele, paper) => {
		$("#loader").show();

		$(ele).css({
			maxHeight: "9000px",
			maxWidth: "9000px",
		});

		let type = "p";
		let size = "a4";

		switch (paper) {
			case "A4V":
				type = "p";
				size = "a4";
				break;
			case "A4H":
				type = "l";
				size = "a4";
				break;
			case "A3V":
				type = "p";
				size = "a3";
				break;
			case "A3H":
				type = "l";
				size = "a3";
				break;
			case "A0V":
				type = "p";
				size = "a0";
				break;
			case "A0H":
				type = "l";
				size = "a0";
				break;
		}

		// PDF
		html2canvas(ele).then(function (canvas) {
			// 캔버스를 이미지로 변환
			var imgData = canvas.toDataURL("image/png");
			var doc;

			doc = new jsPDF(type, "mm", size);
			doc.addImage(imgData, "PNG", 10, 10);

			// 파일 저장
			doc.save("map.pdf");

			$(ele).css({
				maxHeight: "800px",
				maxWidth: "1200px",
			});

			$("#loader").hide();
		});
	};
}
